export enum HandoverHealthStatus {
  INCONSPICUOUS = 'inconspicuous',
  INJURED = 'injured',
  ILL_WEAKENED = 'ill_weakened',
  SEVERELY_NEGLECTED = 'severely_neglected',
}
